<template>
  <div class="order-record">
    <div class="main">
      <!-- Title -->
      <div class="title_bar">
        <div class="left">
          <div class="title">
            {{ $t('OrderFoodRecord.Title') }}
          </div>
          <div class="tip">
            {{ $t('OrderFoodRecord.Tip') }}
          </div>
        </div>
        <div class="right">
          <el-button round @click="$router.push({name: 'pointOrderFoodRecord'})">
            {{ $t('OrderFoodRecord.OldRecord') }}
          </el-button>
        </div>
      </div>
      <div class="subtitle">
        <i class="icon-filter"> </i>
        {{ $t('OrderFoodRecord.Filter') }}
      </div>

      <FilterFrame
        ref="filter"
        :filter-form="orderFoodRecordsFilter"
        @search="onSearch"
        @clear="firstSearch"
      />

      <div class="data-table__title">
        <div>
          <i class="icon-list"></i>
          <span>{{ $t('OrderFoodRecord.ListTitle') }}</span>
        </div>
        <div>
          <span class="data-table__count"> {{ `${$t('OrderFoodRecord.SearchResult')} ${totalCount} ${$t('OrderFoodRecord.SearchResultCount')}` }} </span>
          <el-button @click="handleClickExportReport">
            <div class="order-record__export-btn">
              <span class="mr-8">{{ $t('OrderFoodRecord.ExportReport') }}</span>
              <el-badge type="danger" :value="availableDownloadCount" class="order-record__export-btn-badge" />
            </div>
          </el-button>
          <el-button @click="exportRecord">
            {{ $t('OrderFoodRecord.Export') }}
          </el-button>
        </div>
      </div>
      <el-table :data="orderRecords">
        <el-table-column label="#" type="index" width="50" prop="index"></el-table-column>
        <el-table-column :label="$t('OrderFoodRecord.TableLabelHousehold')">
          <template slot-scope="scope">
            <div>
              {{ scope.row['tabletNote'] }}
            </div>
            <el-button type="danger" size="mini" round>
              {{ scope.row['balance'] }}
            </el-button>
          </template>
        </el-table-column>
        <el-table-column :label="$t('OrderFoodRecord.TableLabelTradePoint')" width="120" prop="actualAmount" align="center">
        </el-table-column>
        <el-table-column :label="$t('OrderFoodRecord.TableLabelPointType')" width="100">
          <template slot-scope="scope">
            <div>
              <el-tooltip
                :disabled="scope.row['paymentMode'] === 1"
                :content="scope.row['paymentMode'] === 2 ? $t('OrderFoodRecord.PointFirstMode') : $t('OrderFoodRecord.CashFirstMode')"
                placement="top"
              >
                <span>
                  {{ scope.row['priceTypeName'] }}
                </span>
              </el-tooltip>
            </div>
          </template>
        </el-table-column>
        <el-table-column :label="$t('OrderFoodRecord.TableLabelTime')" prop="displaySuccessfulAt">
        </el-table-column>
        <el-table-column :label="$t('OrderFoodRecord.TableLabelContent')" width="250">
          <template slot-scope="scope">
            <div v-html="formatRecords(scope.row['receiptRecord'])">
            </div>
          </template>
        </el-table-column>
        <el-table-column :label="$t('OrderFoodRecord.TableLabelNote')" prop="note">
        </el-table-column>
        <el-table-column :label="$t('OrderFoodRecord.TableLabelSystemUser')" prop="successfulUser">
        </el-table-column>
        <el-table-column :label="$t('OrderFoodRecord.TableLabelStatus')">
          <template slot-scope="scope">
            <span :class="scope.row['voidStatus'] === true && 'data-table__void'" @click="scope.row['voidStatus'] && showVoidInfo(scope.row)">
              {{ scope.row['voidStatus'] === false ? $t('OrderFoodRecord.DoneStatus') : $t('OrderFoodRecord.VoidStatus') }}
            </span>
          </template>
        </el-table-column>
        <el-table-column :label="$t('OrderFoodRecord.TableLabelAction')" width="180">
          <template slot-scope="scope">
            <div class="operate">
              <el-tooltip
                :disabled="scope.row['operationStatus'] || scope.row['voidStatus']"
                :content="$t('OrderFoodRecord.OvertimeVoidTip')"
                placement="top"
              >
                <div>
                  <el-button
                    size="mini"
                    type="danger"
                    plain
                    :disabled="!scope.row['operationStatus']"
                    @click="voidOrder(scope.row)"
                  >
                    {{ $t('OrderFoodRecord.Void') }}
                  </el-button>
                </div>
              </el-tooltip>
              <el-tooltip
                :disabled="scope.row['operationStatus']"
                :content="scope.row['voidStatus'] ? $t('OrderFoodRecord.VoidTip') : $t('OrderFoodRecord.OvertimeReprintTip')"
                placement="top"
              >
                <div>
                  <el-button
                    size="mini"
                    type="success"
                    class="reprint-btn"
                    :disabled="!scope.row['operationStatus']"
                    @click="rePrint(scope.row)"
                  >
                    {{ $t('OrderFoodRecord.RePrint') }}
                  </el-button>
                </div>
              </el-tooltip>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <TableLoading :is-loading="loading" />
    </div>
    <RePrintResultDialog ref="rePrintResultDialog" path="orderFoodRecordList" />
    <!-- 點數補足作廢確認 -->
    <el-dialog
      :visible.sync="voidPointSupplementDialog"
      :close-on-click-modal="false"
      :lock-scroll="true"
      center
      custom-class="void-dialog"
      :show-close="false"
    >
      <template #title>
        <div class="void-dialog__header">
          <span class="void-dialog__title el-dialog__title">{{ $t('OrderFoodRecord.VoidPointSupplementTitle') }}</span>
        </div>
      </template>
      <div class="order-record__void-point-supplement-content">
        <div class="order-record__void-point-supplement-content-item">
          <span>{{ $t('OrderFoodRecord.VoidOrderTotalAmount', { totalAmount: voidPointSupplementDialogData.totalAmount, normalPoint: voidPointSupplementDialogData.backNormalPoint, cashPoint: voidPointSupplementDialogData.backCashPoint }) }}</span>
        </div>
        <div class="order-record__void-point-supplement-content-item">
          <span>{{ $t('OrderFoodRecord.VoidBackPoint', { normalPoint: voidPointSupplementDialogData.backNormalPoint, cashPoint: voidPointSupplementDialogData.backCashPoint }) }}</span>
        </div>
        <div class="order-record__void-point-supplement-content-item">
          <span>{{ $t('OrderFoodRecord.VoidPointSupplementConfirm') }}</span>
        </div>
      </div>
      <span
        slot="footer"
        class="dialog-footer"
      >
        <el-button
          round
          @click="voidPointSupplementDialog=false"
        >{{ $t('General.Cancel') }}</el-button>
        <el-button
          type="primary"
          round
          @click="voidPointSupplementDialog=false;voidDialog=true"
        >{{ $t('OrderFoodRecord.VoidSubmitButton') }}</el-button>
      </span>
    </el-dialog>
    <!-- 作廢 -->
    <el-dialog
      :visible.sync="voidDialog"
      :close-on-click-modal="false"
      :lock-scroll="true"
      center
      custom-class="void-dialog"
      :show-close="false"
    >
      <template #title>
        <div class="void-dialog__header">
          <span class="void-dialog__title el-dialog__title">{{ $t('OrderFoodRecord.VoidOrderNote') }}</span>
          <el-tooltip :content="$t('OrderFoodRecord.VoidOrderTip')" placement="top">
            <i class="icon-questions-circular-button"></i>
          </el-tooltip>
        </div>
      </template>
      <el-form ref="voidFormRef" class="void-dialog__form" :model="voidForm" :rules="voidFormRules">
        <el-form-item>
          <el-select v-model="selectedNote" @change="onNoteSelectChange">
            <el-option
              v-for="item in noteTemplates"
              :key="item.Id"
              :label="item.Note"
              :value="item.Note"
            />
          </el-select>
        </el-form-item>
        <el-form-item
          prop="noteInputValue"
        >
          <el-input
            v-model="voidForm.noteInputValue"
            type="textarea" rows="4"
            maxlength="100"
            show-word-limit
          ></el-input>
        </el-form-item>
      </el-form>
      <span
        slot="footer"
        class="dialog-footer"
      >
        <el-button
          round
          @click="closeVoidDialog"
        >{{ $t('General.Cancel') }}</el-button>
        <el-button
          type="primary"
          round
          @click="confirmVoid"
        >{{ $t('OrderFoodRecord.VoidNoteSubmitButton') }}</el-button>
      </span>
    </el-dialog>
    <!-- 作廢確認 -->
    <el-dialog
      :title="$t('OrderFoodRecord.VoidOrderConfirm')"
      :visible.sync="voidConfirmDialog"
      :close-on-click-modal="false"
      :lock-scroll="true"
      center
      custom-class="void-confirm-dialog"
      :show-close="false"
    >
      <div ref="confirmContent" class="void-confirm-dialog__content" @scroll="scrollToConfirm">
        <div class="void-confirm-dialog__note">
          <div>
            {{ $t('OrderFoodRecord.VoidOrderNote') }}
          </div>
          <div>
            {{ voidForm.noteInputValue }}
          </div>
        </div>
        <div class="void-confirm-dialog__detail">
          <div>
            {{ $t('OrderFoodRecord.VoidOrderDetail') }}
          </div>
          <div v-html="voidOrderDetail.receiptRecord">
          </div>
        </div>
      </div>
      <span
        slot="footer"
        class="dialog-footer"
      >
        <el-button
          round
          @click="prevStep"
        >{{ $t('OrderFoodRecord.PrevStep') }}</el-button>
        <el-button
          type="primary"
          round
          :disabled="!isScrollToBottom"
          @click="voidSubmit"
        >{{ $t('OrderFoodRecord.VoidSubmitButton') }}</el-button>
      </span>
    </el-dialog>
    <!-- 作廢成功 -->
    <el-dialog
      :title="$t('OrderFoodRecord.VoidResultSuccess')"
      :visible.sync="voidResultDialog"
      :close-on-click-modal="false"
      :lock-scroll="true"
      center
      custom-class="void-result-dialog"
      :show-close="false"
    >
      <div>
        <div class="void-result-dialog__message">
          <div>
            {{ $t('OrderFoodRecord.VoidResultSuccess') }}
          </div>
          <div>
            {{ $t('OrderFoodRecord.OrderHasBeenVoid') }}，{{ $t('OrderFoodRecord.TableLabelTradePoint') }}
            <span class="void-result-dialog__point">
              {{ voidOrderDetail.actualAmount }}
            </span> {{ $t('OrderFoodRecord.PointsRestoreTo') }} <span class="void-result-dialog__tablet">
              {{ voidOrderDetail.tabletNote }}
            </span>。{{ $t('OrderFoodRecord.OrderVoidReasonUpdateToRestoreTemplate') }}
          </div>
        </div>
        <div class="void-result-dialog__note">
          <div>
            {{ $t('OrderFoodRecord.VoidOrderNote') }}
          </div>
          <div>
            {{ orderResult.note }}
          </div>
        </div>
        <div class="void-result-dialog__detail">
          <div>
            {{ $t('OrderFoodRecord.VoidOrderDetail') }}
          </div>
          <div v-html="orderResult.detail">
          </div>
        </div>
      </div>
      <span
        slot="footer"
        class="dialog-footer"
      >
        <el-button
          type="primary"
          round
          @click="closeVoidResultDialog"
        >{{ $t('General.OK') }}</el-button>
      </span>
    </el-dialog>
    <!-- 已作廢備註 -->
    <el-dialog
      :title="$t('OrderFoodRecord.VoidInfoTitle')"
      :visible.sync="voidInfoDialog"
      :close-on-click-modal="false"
      :lock-scroll="true"
      center
      custom-class="void-info-dialog"
      :show-close="false"
    >
      <div>
        <div class="void-info-dialog__user">
          <div>
            {{ $t('OrderFoodRecord.VoidInfoUser') }}
          </div>
          <div v-html="voidInfo.voidUser">
          </div>
        </div>
        <div class="void-info-dialog__time">
          <div>
            {{ $t('OrderFoodRecord.VoidInfoTime') }}
          </div>
          <div>
            {{ voidInfo.voidAt }}
          </div>
        </div>
        <div class="void-info-dialog__note">
          <div>
            {{ $t('OrderFoodRecord.VoidInfoNote') }}
          </div>
          <div>
            {{ voidInfo.voidNote }}
          </div>
        </div>
        <div class="void-info-dialog__detail">
          <div>
            {{ $t('OrderFoodRecord.VoidInfoDetail') }}
          </div>
          <div v-html="voidInfo.receiptRecord">
          </div>
        </div>
      </div>
      <span
        slot="footer"
        class="dialog-footer"
      >
        <el-button
          type="primary"
          round
          @click="closeVoidInfoDialog"
        >{{ $t('General.OK') }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import dayjs from 'dayjs'
import TableLoading from '@/components/TableLoading'
import FilterFrame from '@/components/FilterFrame.vue'
import RePrintResultDialog from './components/RePrintResultDialog'
import { apiOrderFood } from '@/api/point/orderFood.js'
import { apiOrderFood as apiOrderFoodNew } from '@/api/OrderFood'
import { apiPoint } from '@/api/point/point.js'
import { printThermalPrinter } from '@/js/utils/epos.js'
import { convertKeysToPascalCase, convertKeysToCamelCase } from '@/js/utils/bff'
export default {
  name: 'OrderFoodRecordList',
  components: {
    FilterFrame,
    RePrintResultDialog,
    TableLoading
  },
  data () {
    const orderRecords = []
    return {
      filter: {},
      isScrollToBottom: false,
      loading: false, // state of search api call
      manualSearchProcess: false, // state of manual search process: 手動搜尋有觸發滾動載入行為的可能，故新增狀態區將 '滾動載入' 的行為從手動搜尋的過程中區隔
      scrollEnd: false, // state of data reach the end
      maxCount: 10,
      voidForm: {
        noteInputValue: ''
      },
      voidFormRules: {
        noteInputValue: [
          {
            type: 'string', required: true, message: this.$t('OrderFoodRecord.VoidNoteRequired'), trigger: ['change', 'blur']
          },
          {
            validator: (rule, value, callback) => {
              if (!value || value.trim() === '') {
                callback(new Error(this.$t('OrderFoodRecord.VoidNoteRequired')))
              } else {
                callback()
              }
            },
            trigger: ['change', 'blur']
          }
        ]
      },
      noteTemplates: [],
      offset: 0,
      orderFoodRecordsFilter: [],
      orderRecords,
      orderResult: {},
      printersWithStatusAndResult: [],
      selectedNote: null,
      totalCount: 0, // 搜尋結果筆數
      availableDownloadCount: 0, // 可下載檔案數量
      voidPointSupplementDialog: false, // 作廢點數補足作廢確認
      // 作廢點數補足作廢確認資料
      voidPointSupplementDialogData: {
        totalAmount: null,
        backNormalPoint: null,
        backCashPoint: null
      },
      voidConfirmDialog: false,
      voidDialog: false,
      voidInfo: {
        receiptRecord: [],
        voidNote: '',
        transferAt: '',
        voidUser: ''
      },
      voidInfoDialog: false,
      voidOrderDetail: {
        receiptRecord: [],
        id: null,
        actualAmount: null,
        tabletNote: null
      },
      voidResultDialog: false
    }
  },
  async mounted () {
    try {
      // 讀取結單人員列表
      const systemUsersRes = await apiOrderFood.getSystemUserList()
      const systemUsers = systemUsersRes.data.Data.Staffs.map(user => {
        return {
          key: user.AdminId,
          label: user.AdminName,
          value: user.AdminName
        }
      })

      const today = new Date()
      const firstDayOfMonth = new Date(today.getFullYear(), today.getMonth(), 1)
      this.orderFoodRecordsFilter = [
        {
          label: this.$t('OrderFoodRecord.FilterLabelDate'),
          name: 'date',
          type: 'dateOrMonthPicker',
          value: {
            date: [firstDayOfMonth, today],
            radio: '1'
          },
          options: [
            {
              label: this.$t('OrderFoodRecord.FilterByDate'),
              value: '1'
            }, {
              label: this.$t('OrderFoodRecord.FilterByMonth'),
              value: '2'
            }
          ]
        },
        {
          label: this.$t('OrderFoodRecord.FilterLabelHousehold'),
          name: 'household',
          type: 'house',
          value: ''
        },
        {
          label: this.$t('OrderFoodRecord.FilterLabelSystenUser'),
          name: 'successfulUser',
          type: 'select',
          clearable: true,
          value: '',
          options: systemUsers
        },
        {
          label: this.$t('OrderFoodRecord.FilterLabelPointType'),
          name: 'priceType',
          type: 'radio',
          value: '',
          options: [
            {
              label: this.$t('OrderFoodRecord.FilterPointTypeNormal'),
              value: 1
            }, {
              label: this.$t('OrderFoodRecord.FilterPointTypeCash'),
              value: 2
            }
          ]
        },
        {
          label: this.$t('OrderFoodRecord.FilterLabelStatus'),
          name: 'state',
          type: 'radio',
          value: '',
          options: [
            {
              label: this.$t('OrderFoodRecord.FilterStatusVoid'),
              value: 8
            }, {
              label: this.$t('OrderFoodRecord.FilterStatusDone'),
              value: 7
            }
          ]
        }
      ]

      this.getVoidNoteTemplates()
      this.getAvailableDownloadCount()
      this.firstSearch()

      window.addEventListener('scroll', this.scrollToLoad, true)
    } catch (err) {
      console.log(err)
    }
  },
  beforeDestroy () {
    window.removeEventListener('scroll', this.scrollToLoad, true)
  },
  methods: {
    // 處理首次查詢
    firstSearch () {
      const today = new Date()
      const firstDayOfMonth = new Date(today.getFullYear(), today.getMonth(), 1)
      this.filter = {
        startDateTime: dayjs(firstDayOfMonth).format('YYYY-MM-DD'),
        endDateTime: dayjs(today).format('YYYY-MM-DD')
      }
      this.fetchOrderResult()
    },
    // 查詢點餐紀錄
    async fetchOrderResult () {
      try {
        if (this.scrollEnd || this.loading) return
        this.loading = true

        const params = {
          ...this.filter,
          offset: this.offset,
          maxCount: this.maxCount
        }
        const { data, status } = convertKeysToCamelCase((await apiOrderFoodNew.getFoodFormList(convertKeysToPascalCase(params))).data)
        if (status === 1) {
          const dataList = data.tableFoodForms
          this.totalCount = data.totalCount
          if (dataList.length < this.maxCount) {
            this.scrollEnd = true
          }
          this.offset += this.maxCount
          await this.$sleep(300)
          this.orderRecords = [...this.orderRecords, ...dataList.map(item => { return {
            ...item,
            displaySuccessfulAt: dayjs(item.successfulAt).format('YYYY/MM/DD HH:mm')
          } })]
          return true
        }
      } catch (error) {
        console.log(error)
        return false
      } finally {
        this.loading = false
      }
    },
    /**
     * 處理並回傳交易項目字串內容
     * @param {string} records
     */
    formatRecords (records) {
      if (records) {
        return records.replaceAll('\n', '<br/>')
      } else {
        return ''
      }
    },
    onNoteSelectChange (value) {
      this.voidForm.noteInputValue = value
    },
    /**
     * 查詢
     * @param {Object} data 查詢條件
     */
    onSearch: async function (data) {
      if (this.manualSearchProcess) return
      this.manualSearchProcess = true

      this.offset = 0
      this.scrollEnd = false
      this.orderRecords = []
      if (data) {
        // 依月份查詢把結束月份設為當月最後一天
        if (data.dateRadio === '2') {
          data.dateDate[1] = new Date(data.dateDate[1].getFullYear(), data.dateDate[1].getMonth() + 1, 0)
        }
        this.filter = {
          startDateTime: dayjs(data.dateDate[0]).format('YYYY-MM-DD'),
          endDateTime: dayjs(data.dateDate[1]).format('YYYY-MM-DD'),
          tabletId: data.household && data.household.TabletId, // 戶號
          successfulUser: data.successfulUser, // 結單人員
          priceType: data.priceType, // 點數類型
          state: data.state // 訂單狀態
        }
      }
      await this.fetchOrderResult()
      this.manualSearchProcess = false
    },
    // 滾動加載
    async scrollToLoad () {
      if (this.manualSearchProcess) return
      this.$handleScrollWithLoading(this.fetchOrderResult)
    },
    // 取得可下載點餐報表的數量
    async getAvailableDownloadCount () {
      try {
        const params = {
          startDateTime: dayjs().subtract(7, 'day').format('YYYY-MM-DD'),
          endDateTime: dayjs().format('YYYY-MM-DD')
        }
        const { status, data } = convertKeysToCamelCase((await apiOrderFoodNew.getCompletedAndDownloadable(convertKeysToPascalCase(params))).data)
        if (status === 1) {
          this.availableDownloadCount = data.totalCount
        }
      } catch (error) {
        console.log(error)
      }
    },
    // 處理點擊匯出報表
    handleClickExportReport () {
      this.$router.push({ name: 'orderFoodExportReport' })
    },
    // 匯出點餐紀錄
    exportRecord () {
      const filterData = this.$refs.filter.selectedValue
      let startDateTime, endDateTime
      if (filterData.dateRadio === '1') {
        // 依日期
        startDateTime = dayjs(filterData.dateDate[0]).format('YYYY-MM-DD')
        endDateTime = dayjs(filterData.dateDate[1]).format('YYYY-MM-DD')
      } else if (filterData.dateRadio === '2') {
        // 依月分
        startDateTime = dayjs(filterData.dateDate[0]).startOf('month').format('YYYY-MM-DD')
        endDateTime = dayjs(filterData.dateDate[1]).endOf('month').format('YYYY-MM-DD')
      }
      // 匯出參數
      const params = {
        startDateTime,
        endDateTime,
        ...(filterData.household && { tabletId: filterData.household.TabletId }),
        ...(filterData.successfulUser && { successfulUser: filterData.successfulUser }),
        ...(filterData.priceType !== undefined && { priceType: filterData.priceType }),
        ...(filterData.state !== undefined && { state: filterData.state })
      }
      try {
        apiOrderFoodNew.exportFoodForm(convertKeysToPascalCase(params), { responseType: 'blob' }).then(res => {
          const fileName = `${decodeURIComponent(res.headers['content-disposition'].split(';')[2].replace(/"/g, '').replace("filename*=UTF-8''", '')).trim()}`
          const nameSplits = fileName.split('_')
          // 日期居間以「-」符號間隔
          this.$downloadFile(res.data, `${nameSplits[0]}_${nameSplits[1]}_${nameSplits[2]}-${nameSplits[3]}`)
        })
      } catch (error) {
        console.log(error)
        this.$message.error(this.$t('OrderFoodRecord.ExportFailed'))
      }
    },
    // Step1. 作廢
    voidOrder ({ id, actualAmount, tabletNote, receiptRecord, paymentMode, normalActualTotalAmount, cashActualTotalAmount }) {
      // 先記錄作廢訂單資料
      this.voidOrderDetail = {
        id, // 訂單id
        actualAmount, // 交易點數
        tabletNote, // 戶號
        receiptRecord: this.formatRecords(receiptRecord) // 訂單明細
      }

      // 是否為一般訂單
      if (paymentMode === 1) {
        this.voidDialog = true
      } else {
        // 如果是點數補足的訂單
        this.voidPointSupplementDialogData = {
          totalAmount: actualAmount,
          backNormalPoint: normalActualTotalAmount,
          backCashPoint: cashActualTotalAmount
        }
        this.voidPointSupplementDialog = true
      }
    },
    async getVoidNoteTemplates () {
      try {
        const res = await apiOrderFood.getVoidNoteTemplates()
        this.noteTemplates = res.data.Data?.NoteTemplates
      } catch (error) {
        console.log(error)
      }
    },
    // Step1. 取消
    closeVoidDialog () {
      this.selectedNote = null
      this.voidForm.noteInputValue = ''
      this.voidDialog = false
    },
    // Step1. 確認作廢訂單
    confirmVoid () {
      this.$refs.voidFormRef.validate(valid => {
        if (valid) {
          this.voidConfirmDialog = true
          this.isScrollToBottom = false
          this.$nextTick(() => {
            const scrollable = this.$refs.confirmContent
            const maxHeight = parseInt(window.getComputedStyle(scrollable).maxHeight, 10)
            if (scrollable.scrollHeight <= maxHeight) {
              this.isScrollToBottom = true
            } else {
              scrollable.scrollTop = 0
            }
          })
        }
      })
    },
    // Step2. 上一步
    prevStep () {
      this.voidConfirmDialog = false
    },
    // 滾動到底部以便確認
    scrollToConfirm () {
      const scrollable = this.$refs.confirmContent
      // 由於放大縮小會有小數點誤差，所以用小於1來判斷是否在底部
      const isAtBottom =
        Math.abs(scrollable.scrollHeight - scrollable.scrollTop - scrollable.clientHeight) < 1
      if (isAtBottom) {
        this.isScrollToBottom = true
      }
    },
    // Step2. 確定作廢
    async voidSubmit () {
      try {
        const { status } = convertKeysToCamelCase((await apiOrderFoodNew.voidFoodForm(this.voidOrderDetail.id, convertKeysToPascalCase({ note: this.voidForm.noteInputValue }))).data)
        if (status === 1) {
          this.orderResult = {
            message: `訂單已作廢，交易點數 ${this.voidOrderDetail.actualAmount} 點已回補至 ${this.voidOrderDetail.tabletNote}。訂單作廢原因已同步更新至「點數回補備註」`,
            note: this.voidForm.noteInputValue,
            detail: this.formatRecords(this.voidOrderDetail.receiptRecord)
          }
          this.voidResultDialog = true
          this.offset = 0
          this.orderRecords = []
          this.scrollEnd = false
          await this.fetchOrderResult()
        }
      } catch (error) {
        console.log(error)
      } finally {
        this.selectedNote = null
        this.voidForm.noteInputValue = ''
        this.voidConfirmDialog = false
        this.voidDialog = false
      }
    },
    closeVoidResultDialog () {
      this.voidResultDialog = false
    },
    // 顯示作廢備註
    showVoidInfo ({ voidUser, voidAt, voidNote, receiptRecord }) {
      this.voidInfoDialog = true
      this.voidInfo = {
        receiptRecord: this.formatRecords(receiptRecord),
        voidNote,
        voidAt: dayjs(voidAt).format('YYYY/MM/DD HH:mm'),
        voidUser
      }
    },
    closeVoidInfoDialog () {
      this.voidInfoDialog = false
    },
    /**
     * 處理補單
     * @param {*} targetRow 補單資料
     */
    async rePrint (targetRow) {
      const loading = this.$loading({
        lock: true,
        text: '處理中，請稍候',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      try {
        const { status, data } = convertKeysToCamelCase((await apiOrderFoodNew.getFoodFormData(targetRow.id)).data)
        if (status === 1) {
          // 點餐項目
          const items = data.items.map(el => {
            return {
              name: el.itemName, // 餐點品項名稱
              quantity: el.quantity, // 數量
              price: el.unitPrice, // 單價(點數)
              displaySpec: el.chooses.map(c => c.name).join(', ') // 規格
            }
          })

          let normalPointBefore = targetRow.balance + targetRow.actualAmount // 一般點數(交易前)
          let cashPointBefore = targetRow.balance + targetRow.actualAmount // 現金點數(交易前)
          let normalPointAfter = targetRow.balance // 一般點數(交易後)
          let cashPointAfter = targetRow.balance // 現金點數(交易後)
          // 處理明細單顯示的點數資訊
          // 如果是點數補足的訂單(paymentMode = 2 或 3)
          if ([2, 3].includes(targetRow.paymentMode)) {
            if (targetRow.priceType === 1) {
              normalPointBefore = targetRow.normalActualTotalAmount
              cashPointBefore = targetRow.cashBalance + targetRow.cashActualTotalAmount
              normalPointAfter = targetRow.normalBalance
              cashPointAfter = targetRow.cashBalance
            } else {
              normalPointBefore = targetRow.normalBalance + targetRow.normalActualTotalAmount
              cashPointBefore = targetRow.cashActualTotalAmount
              normalPointAfter = targetRow.normalBalance
              cashPointAfter = targetRow.cashBalance
            }
          }

          const receiptObj = {
            userId: targetRow.tabletNote,
            items,
            isPointSupplement: [2, 3].includes(targetRow.paymentMode), // 是否啟用點數補足功能
            selectedPointType: targetRow.priceType, // 選擇的交易點數類別
            totalPoint: targetRow.actualAmount, // 交易點數合計
            normalPointBefore, // 一般點數(交易前)
            cashPointBefore, // 現金點數(交易前)
            normalPointAfter, // 一般點數(交易後)
            cashPointAfter, // 現金點數(交易後)
            staff: targetRow.successfulUser,
            date: dayjs(targetRow.successfulAt).format('YYYY-MM-DD HH:mm:ss')
          }
          const res = await this.printAllPrinters(receiptObj)
          this.printersWithStatusAndResult = res
          this.$refs.rePrintResultDialog.setVal(this.printersWithStatusAndResult)
        }
      } catch (error) {
        console.log(error)
      } finally {
        loading.close()
      }
    },
    /**
     * 列印所有出單機
     * @param {*} data 列印資料
     */
    async printAllPrinters (data) {
      try {
        const printerRes = await apiPoint.getCommunityPrinters()
        const printers = printerRes.data.Data.Printers
        const promiseArr = printers.map(el => printThermalPrinter(2, el.Ip, data))
        // 每台出單機都需要回傳出單結果
        const res = await Promise.allSettled(promiseArr)
        printers.forEach((el, index) => {
          el.IsFulfilled = res[index].status === 'fulfilled'
          el.Result = res[index].status === 'fulfilled' ? '列印成功' : '出單機列印失敗，請聯絡業務'
        })
        return printers
      } catch (error) {
        console.log(error)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.order-record {
  @include mainLayer();
  .subtitle {
    display: flex;
    align-items: center;
    margin-top: 2rem;
    margin-bottom: 1rem;
    i {
      margin-right: 5px;
    }
  }
  .filter {
    margin-bottom: 2rem;
    .title {
      font-weight: bold;
      background-color: #ecefee;
      color: #333;
    }
    .el-col {
      display: flex;
      justify-content: center;
      align-items: center;
      border: 1px solid #ccc;
      height: 100px;
    }
  }

  .data-table {
    &__title {
      display: flex;
      align-items: center;
      justify-content: space-between;
      text-align: left;
      margin-top: 2rem;
      margin-bottom:1rem;
      i {
        margin-right: 0.5rem;
      }
    }
    &__count{
      margin-right:.5rem;
    }
    &__void{
      text-decoration: underline;
      cursor: pointer;
      color:$warnColor
    }
  }

  .operate {
    display: flex;
    .reprint-btn {
      margin-left:10px
    }
  }

  ::v-deep .el-table{
    @include basicTable;
    &__body a.el-button--default.is-plain{
      color: #333
    }
  }

  ::v-deep .void-dialog{
    @include basicDialog;
    &__header{
      display: flex;
      align-items: center;
    }
    &__title{
      margin-right:.5rem
    }
    i{
      font-size: map-get($fontSize,large);
      color:$mainColor
    }
    &__form{
     .el-form-item,.el-select{
      width: 100%;
     }
    }
  }

  ::v-deep  .void-confirm-dialog{
    @include basicDialog;
    .el-dialog__body{
      overflow-y: auto;
    }
    &__content{
      max-height:300px;
      overflow-y: auto;
    }
    &__note,&__detail{
      display: flex;
      font-weight: bold;
      width: 100%;
      line-height: 2rem;
      :nth-child(1){
        width:30%;
      }
      :nth-child(2){
        width: 70%;
      }
    }
    &__note{
      padding-bottom:1rem;
      border-bottom: $lightFontColor 1px solid;
      margin-bottom:1rem;
    }
  }

  ::v-deep .void-result-dialog{
    @include basicDialog;
    .el-dialog__body{
      overflow-y: auto;
    }
    &__point,&__tablet{
      color:$warnColor
    }
    &__note,&__detail,&__message{
      display: flex;
      font-weight: bold;
      width: 100%;
      line-height: 2rem;
      :nth-child(1){
        width:30%;
      }
      :nth-child(2){
        width: 70%;
      }
    }
    &__note,&__message{
      padding-bottom:1rem;
      border-bottom: $lightFontColor 1px solid;
      margin-bottom:1rem;
    }
  }

  ::v-deep .void-info-dialog{
    @include basicDialog;
    &__time,&__detail,&__note,&__user{
      display: flex;
      font-weight: bold;
      width: 100%;
      line-height: 2rem;
      :nth-child(1){
        width:30%;
      }
      :nth-child(2){
        width: 70%;
      }
    }
    &__note,&__time,&__user{
      padding-bottom:1rem;
      border-bottom: $lightFontColor 1px solid;
      margin-bottom:1rem;
    }
  }

  &__export-btn {
    display: flex;
    align-items: center;
    &-badge {
      width: 20px;
      height: 20px;
    }
  }

  &__void-point-supplement-content{
    display: flex;
    flex-direction: column;
    gap: 1rem;
    font-size: map-get($fontSize, medium);
  }
}
</style>
